import { render } from "./leave-balance.vue?vue&type=template&id=23f36ab0"
import script from "./leave-balance.vue?vue&type=script&lang=js"
export * from "./leave-balance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__